var _MicrofrontendManager_instances, _MicrofrontendManager_config, _MicrofrontendManager_setupModules, _MicrofrontendManager_setupCacheModule, _MicrofrontendManager_setupRecognitionModule, _MicrofrontendManager_setupLegacyAccountModule, _MicrofrontendManager_setupSettingsModule, _MicrofrontendManager_setupAnalyticsModule;
var MicrofrontendManager_1;
import { __awaiter, __classPrivateFieldGet, __classPrivateFieldSet, __decorate, __metadata } from "tslib";
import { container, singleton } from 'tsyringe';
import { CacheManager } from './CacheManager';
import { RecognitionManager } from './RecognitionManager';
import { LegacyAccountManager } from './LegacyAccountManager';
import { SettingsManager } from './SettingsManager';
import { AnalyticsManager } from './AnalyticsManager';
let MicrofrontendManager = MicrofrontendManager_1 = class MicrofrontendManager {
    constructor(recognitionManager, legacyAccountManager, settingsManager, cacheManager, analyticsManager) {
        _MicrofrontendManager_instances.add(this);
        this.recognitionManager = recognitionManager;
        this.legacyAccountManager = legacyAccountManager;
        this.settingsManager = settingsManager;
        this.cacheManager = cacheManager;
        this.analyticsManager = analyticsManager;
        _MicrofrontendManager_config.set(this, void 0);
    }
    static init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            const instance = container.resolve(MicrofrontendManager_1);
            yield __classPrivateFieldGet(instance, _MicrofrontendManager_instances, "m", _MicrofrontendManager_setupModules).call(instance, config);
        });
    }
    get config() {
        return __classPrivateFieldGet(this, _MicrofrontendManager_config, "f");
    }
};
_MicrofrontendManager_config = new WeakMap();
_MicrofrontendManager_instances = new WeakSet();
_MicrofrontendManager_setupModules = function _MicrofrontendManager_setupModules(config) {
    return __awaiter(this, void 0, void 0, function* () {
        __classPrivateFieldSet(this, _MicrofrontendManager_config, config, "f");
        yield __classPrivateFieldGet(this, _MicrofrontendManager_instances, "m", _MicrofrontendManager_setupCacheModule).call(this);
        yield __classPrivateFieldGet(this, _MicrofrontendManager_instances, "m", _MicrofrontendManager_setupRecognitionModule).call(this);
        yield __classPrivateFieldGet(this, _MicrofrontendManager_instances, "m", _MicrofrontendManager_setupLegacyAccountModule).call(this);
        yield __classPrivateFieldGet(this, _MicrofrontendManager_instances, "m", _MicrofrontendManager_setupSettingsModule).call(this);
        yield __classPrivateFieldGet(this, _MicrofrontendManager_instances, "m", _MicrofrontendManager_setupAnalyticsModule).call(this);
    });
};
_MicrofrontendManager_setupCacheModule = function _MicrofrontendManager_setupCacheModule() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!((_a = __classPrivateFieldGet(this, _MicrofrontendManager_config, "f").caching) === null || _a === void 0 ? void 0 : _a.namespace)) {
                return;
            }
            yield this.cacheManager.init(__classPrivateFieldGet(this, _MicrofrontendManager_config, "f"));
        }
        catch (error) {
            console.warn('Unable to start Cache Module');
        }
    });
};
_MicrofrontendManager_setupRecognitionModule = function _MicrofrontendManager_setupRecognitionModule() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if ((_a = __classPrivateFieldGet(this, _MicrofrontendManager_config, "f").recognition) === null || _a === void 0 ? void 0 : _a.isEnabled) {
                yield this.recognitionManager.init(__classPrivateFieldGet(this, _MicrofrontendManager_config, "f"));
            }
        }
        catch (error) {
            console.warn('Unable to start Credential Module');
            throw error;
        }
    });
};
_MicrofrontendManager_setupLegacyAccountModule = function _MicrofrontendManager_setupLegacyAccountModule() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if ((_a = __classPrivateFieldGet(this, _MicrofrontendManager_config, "f").legacyAccount) === null || _a === void 0 ? void 0 : _a.isEnabled) {
                yield this.legacyAccountManager.init(__classPrivateFieldGet(this, _MicrofrontendManager_config, "f"));
            }
        }
        catch (error) {
            console.warn('Unable to start Legacy Credential Module');
            throw error;
        }
    });
};
_MicrofrontendManager_setupSettingsModule = function _MicrofrontendManager_setupSettingsModule() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!((_a = __classPrivateFieldGet(this, _MicrofrontendManager_config, "f").settings) === null || _a === void 0 ? void 0 : _a.launchDarklyClientId)) {
                return;
            }
            yield this.settingsManager.init(__classPrivateFieldGet(this, _MicrofrontendManager_config, "f"));
        }
        catch (error) {
            console.warn('Unable to start Settings Module');
            throw error;
        }
    });
};
_MicrofrontendManager_setupAnalyticsModule = function _MicrofrontendManager_setupAnalyticsModule() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (!((_a = __classPrivateFieldGet(this, _MicrofrontendManager_config, "f").analytics) === null || _a === void 0 ? void 0 : _a.isEnabled)) {
                return;
            }
            yield this.analyticsManager.init(__classPrivateFieldGet(this, _MicrofrontendManager_config, "f"));
        }
        catch (error) {
            console.warn('Unable to start Analytics Module');
            throw error;
        }
    });
};
MicrofrontendManager = MicrofrontendManager_1 = __decorate([
    singleton(),
    __metadata("design:paramtypes", [RecognitionManager,
        LegacyAccountManager,
        SettingsManager,
        CacheManager,
        AnalyticsManager])
], MicrofrontendManager);
export { MicrofrontendManager };
